import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://demo.myssa.net/api';

const PALETTE = ['#3ab56f', '#bfc64b'];

const CamembertOccupation = () => {
  const [occupé, setOccupé]   = useState(95);
  const [vide, setVide]       = useState(5);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      fetch(`${API}/emplacement_vide`).then(r => r.json()),
      fetch(`${API}/base_de_donne_stock`).then(r => r.json()),
    ])
    .then(([emplacementsVides, stock]) => {

      // Nombre d'emplacements vides
      const nbVides = emplacementsVides.length;

      // Nombre d'emplacements uniques dans le stock
      // (combinaison "Nom Dépôt" + "Emplacement")
      const uniqueEmplacements = new Set(
        stock.map(row => `${row['Nom Dépôt']}||${row['Emplacement']}`)
      );
      const nbTotal = uniqueEmplacements.size;

      // Emplacements occupés = total - vides
      const nbOccupés = Math.max(0, nbTotal - nbVides);

      setOccupé(nbOccupés);
      setVide(nbVides);
    })
    .catch(err => console.error('Erreur CamembertOccupation:', err))
    .finally(() => setLoading(false));
  }, []);

  const total = occupé + vide;
  const pctOccupé = total > 0 ? Math.round((occupé / total) * 100) : 0;
  const pctVide   = total > 0 ? Math.round((vide   / total) * 100) : 0;

  const data = {
    labels: [
      `Occupé (${pctOccupé}% — ${occupé} empl.)`,
      `Vide (${pctVide}% — ${vide} empl.)`,
    ],
    datasets: [{
      data: [occupé, vide],
      backgroundColor: PALETTE.map(c => c + 'cc'),
      borderColor: '#ffffff',
      borderWidth: 2,
      hoverOffset: 6,
    }],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: "TAUX D'OCCUPATION",
        color: '#04202d',
        font: { family: "'IBM Plex Mono', monospace", size: 20, weight: '500' },
        padding: { bottom: 16 },
      },
      tooltip: {
        backgroundColor: '#ffffff',
        borderColor: '#f0ece2',
        borderWidth: 1,
        titleColor: '#66c292',
        bodyColor: '#8b7b64',
        titleFont: { family: "'IBM Plex Mono', monospace", size: 20 },
        bodyFont: { family: "'IBM Plex Sans', sans-serif", size: 20 },
        padding: 10,
        callbacks: {
          label: (ctx) => {
            const val = ctx.raw;
            const pct = total > 0 ? Math.round((val / total) * 100) : 0;
            return ` ${val} emplacements (${pct}%)`;
          },
        },
      },
      legend: {
        position: 'bottom',
        labels: {
          color: '#8b7b64',
          font: { family: "'IBM Plex Sans', sans-serif", size: 11 },
          boxWidth: 12,
          boxHeight: 12,
          padding: 14,
        },
      },
    },
  };

  return (
    <div style={{
      background: '#ffffff',
      border: '1px solid #f0ece2',
      borderRadius: '14px',
      padding: '20px 24px',
      boxShadow: '0 2px 12px rgba(148, 99, 46, 0.06)',
      position: 'relative',
      overflow: 'hidden',
      width: '400px',
      height: '440px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', borderRadius: '14px 14px 0 0' }} />
      {loading
        ? <span style={{ color: '#8b7b64', fontFamily: "'IBM Plex Mono', monospace", fontSize: 12 }}>Chargement…</span>
        : <Pie data={data} options={options} width={800} height={360} />
      }
    </div>
  );
};

export default CamembertOccupation;